import { SupportedGeo, SupportedLanguage } from './config'

export const VARIANT_COPY_KEYS: Partial<
  Record<SupportedLanguage, Partial<Record<SupportedGeo, readonly string[]>>>
> = {
  en: {
    AZ: ['hero.title-line-1', 'hero.currency'],
    KZ: ['hero.title-line-1', 'hero.currency'],
    UZ: ['hero.title-line-1', 'hero.currency'],
    KG: ['hero.title-line-1', 'hero.currency'],
  },
  ru: {
    AZ: ['hero.title-line-1', 'hero.currency'],
    KZ: ['hero.title-line-1', 'hero.currency'],
    UZ: ['hero.title-line-1', 'hero.currency'],
    KG: ['hero.title-line-1', 'hero.currency'],
  },
  tr: {
    AZ: ['hero.title-line-1', 'hero.currency'],
    KZ: ['hero.currency'],
    UZ: ['hero.currency'],
    KG: ['hero.currency'],
  },
  az: {
    AZ: ['hero.title-line-1', 'hero.currency'],
    KZ: ['hero.currency'],
    UZ: ['hero.currency'],
    KG: ['hero.currency'],
  },
  kz: {
    KZ: ['hero.title-line-1', 'hero.currency'],
    AZ: ['hero.currency'],
    UZ: ['hero.currency'],
    KG: ['hero.currency'],
  },
  uz: {
    UZ: ['hero.title-line-1', 'hero.currency'],
    KZ: ['hero.currency'],
    AZ: ['hero.currency'],
    KG: ['hero.currency'],
  },
  ky: {
    KG: ['hero.title-line-1', 'hero.currency'],
    KZ: ['hero.currency'],
    UZ: ['hero.currency'],
    AZ: ['hero.currency'],
  },
}
